module.exports = __webpack_public_path__ + "media/images/thumbs/biology/v_qv_granular_myeloid_white_blood_cells_2-e0098630661c6467143e05e64ab76667.jpg";